import type {ClassValue} from 'clsx';

import {clsx} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

// Keep in sync with `@utility text-*` names in theme/styles/typography.css.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'heading-h1',
        'heading-h2',
        'heading-h3',
        'heading-h4',
        'heading-h5',
        'subtitle-lg',
        'subtitle-md',
        'subtitle-sm',
        'subtitle-xs',
        'body-xl',
        'body-xl-emphasis',
        'body-lg',
        'body-lg-emphasis',
        'body-md',
        'body-md-emphasis',
        'body-sm',
        'body-sm-emphasis',
        'body-xs',
        'body-xs-emphasis',
        'button-lg',
        'button-md',
        'button-sm',
        'field-input-placeholder',
        'field-input-value',
        'field-caption',
        'field-caption-emphasis'
      ]
    }
  }
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type {ClassValue};
